import { Space } from "antd";
import styled from "styled-components";
import { IMG_BOTTOM_NAVIGATION } from "@assets";

export const Container = styled(Space)`
	width: 100%;
	max-width: 480px;
	padding: 12px 0 10px;
	align-items: flex-end;
	text-align: center;
	background-image: url(${IMG_BOTTOM_NAVIGATION});
	background-size: 100%;
  background-repeat: no-repeat;
	.ant-space-item {
		flex: 0.25;
	}
	position: fixed;
	bottom: 0;
  margin-bottom: 0;
	z-index: 600;
`;

export const ItemWrapper = styled.div`
	text-align: center;
	cursor: pointer;
	#msg-active-icon {
		width: 26px;
		height: 26px;
	}

	margin-right: ${(props) => props.index === 1 && "1em"};
	margin-left: ${(props) => props.index === 2 && "1em"};

	@media screen and (max-width: 430px) {
		margin-right: ${(props) => props.index === 1 && "15px"};
		margin-left: ${(props) => props.index === 2 && "15px"};
	}
	@media screen and (max-width: 360px) {
		margin-right: 0;
		margin-left: 0;
	}
`;

export const Label = styled.div`
	font-size: 12px;
	font-weight: 500;
	font-style: normal;
	letter-spacing: normal;
	color: ${(props) =>
		props.status === "active" ? props.theme.primarySolid : props.theme.dark2};

	@media screen and (max-width: 352px) {
		font-size: 11px;
	}

	@media screen and (max-width: 325px) {
		font-size: 10px;
	}

	@media screen and (max-width: 298px) {
		font-size: 9px;
	}

	@media screen and (max-width: 272px) {
		font-size: 8px;
	}
`;
